import { Component, OnInit } from '@angular/core';
import { ClientTableConfig } from "./client.table-config";
import { BrokerService } from '@app/services';
import { ApiResponse } from '@app/interfaces';
import { ClientService } from '@app/services';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@app/constants';
@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss']
})
export class ClientListComponent implements OnInit {
  addPanel: boolean = false;
  config: any;
  isLoading: boolean = false;
  dataSource: any = []
  editSelected: any;

  constructor(
    private clientService: ClientService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.config = ClientTableConfig.configure();
    this.getList();
  }

  getList() {
    this.isLoading = true;
    this.clientService.list().subscribe({
      next: (res: any) => {
        this.isLoading = false;
        res.data.forEach((o: any) => {
          o.user.name = `${o.user?.firstName} ${o.user?.lastName ?? ""}`
        })
        this.dataSource = res.data
      }
    })
  }

  action(e: any) {
    this.editSelected = null;
    if(e.button.eventName == "edit") {
      this.router.navigate([APP_ROUTES.CLIENT_DETAIL], {
        queryParams: { clientId: e.data._id }
      })
      // this.editSelected = e.data
      // this.addPanel = true;
    }
    if(e.button.eventName == "add") {
      this.router.navigate([APP_ROUTES.CLIENT_DETAIL])
    }
  }

  onPopupclose() {
    this.addPanel = false
    this.editSelected = null;
    this.getList();
  }

}
